import { YhBox } from '@/components/YhBox'
import { YHModal } from "@/components/YHModal";
import { DataTable } from './DataTable'

interface PropsType {
    visible: boolean;
    setVisible: (flag: boolean) => void;
}
export const SettleDetail = (props: PropsType) => {

    const { visible, setVisible } = props;
    const onCancel = () => {
        if (visible) {
            setVisible(false);
        }
    }

    return (
        <>
            <YHModal visible={visible} title="账单明细" showFooter={false} width={1200} bodyHeight={600} onCancel={onCancel}>
                <YhBox title="" style={{ height: 'calc(100vh - 185px)', padding: 10 }}>
                    <DataTable />
                </YhBox>
            </YHModal>
        </>
    )
}
